<template>
    <VJoyWrapper no-margin column-gap="1" wrap="nowrap">
        <VJoyIcon name="location" color="neutral-50" size="xsmall" />
        <span class="location-indicator__text" :class="{'location-indicator__text--bold': bold}">{{ location }}</span>
    </VJoyWrapper>
</template>
<script setup lang="ts">
    import {computed} from 'vue';
    import {VJoyIcon, VJoyWrapper} from '@maltjoy/core-vue';
    import type {AddressResource} from '~/types/api-raw-types';

    const props = defineProps<{
        address: AddressResource;
        bold?: boolean;
    }>();

    const location = computed(() =>
        props.address?.city && props.address?.countryCode ? `${props.address.city}, ${props.address.countryCode}` : '-',
    );
</script>

<style scoped lang="scss">
    .location-indicator {
        &__text {
            white-space: nowrap;

            &--bold {
                font-weight: var(--joy-font-weight-bold);
            }
        }
    }
</style>
